/**
 * Distingue host da plataforma (lumenise.app, *.lumenise.app, localhost,
 * *.pages.dev) de domínio custom de cliente (Cloudflare for SaaS) — usado
 * tanto pelo roteamento (RootDispatch, router/index.tsx) quanto pelo gate de
 * registro do service worker (main.tsx), pra manter as duas decisões
 * sincronizadas com uma única fonte de verdade.
 */
export function isPlatformHost(hostname: string = window.location.hostname.toLowerCase()): boolean {
  const platformHostname = (import.meta.env.VITE_PLATFORM_HOSTNAME as string | undefined) ?? 'lumenise.app';
  return (
    hostname === platformHostname ||
    hostname.endsWith(`.${platformHostname}`) ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.pages.dev')
  );
}
